<ng-container *ngIf="currentListViewState" ntapDynamicFormProvider>
    <ng-container ntapFilterViewProvider [viewName]="currentListViewName" [viewState]="currentListViewStateFilter">
        <ng-container ntapListViewProvider [viewName]="currentListViewName" [viewState]="currentListViewState">
            <ntap-dynamic [compId]="INIT_COMP_ID"></ntap-dynamic>
            <p-button styleClass="mt-3" ntapDebounceClick [disabled]="(disabled$ | async) ?? true" pRipple label="Potvrdi" (onClick)="razmjestiFizickeObjekte()" />
        </ng-container>
    </ng-container>
</ng-container>